import { render, staticRenderFns } from "./bindUinId.vue?vue&type=template&id=73802282&scoped=true"
import script from "./bindUinId.vue?vue&type=script&lang=js"
export * from "./bindUinId.vue?vue&type=script&lang=js"
import style0 from "./bindUinId.vue?vue&type=style&index=0&id=73802282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73802282",
  null
  
)

export default component.exports